import type {KeyValue} from '@jetbrains/teamcity-ui/dist/utils'

import type {PipelineId} from '../../../../../types'
import type {NewPipeline, Pipeline} from '../../services/pipelinesApi.types'

export type PipelineDraft = {
  original?: Pipeline
  draft?: NewPipeline
  isCollisionApi?: boolean
  deleted?: {
    jobs?: string[]
    jobParameters?: string[]
    outputParameters?: string[]
    filesPublication?: string[]
    parameters?: string[]
    steps?: Record<string, number[]>
    integrations?: string[]
    secrets?: string[]
    additionalVcsRoots?: string[]
    incompleteAdditionalVcsRoots?: number[]
    notifications?: string[]
    importParameters?: string[]
    dependencies?: string[]
  }
  renamed?: {
    outputParameters?: Record<string, string>
    jobParameters?: Record<string, string>
    parameters?: Record<string, string>
    integrations?: Record<string, string>
    secrets?: Record<string, string>
    notifications?: Record<string, boolean>
  }
  reordered?: {
    steps?: Record<string, number[]>
  }
  added?: {
    outputParameters?: Record<string, boolean>
    jobParameters?: Record<string, boolean>
    filesPublication?: Record<string, boolean>
    parameters?: Record<string, boolean>
    secrets?: Record<string, boolean>
    notifications?: Record<string, boolean>
    importParameters?: Record<string, boolean>
    dependencies?: Record<string, boolean>
  }
}

export type PipelineDraftState = KeyValue<string, PipelineDraft>

export enum FormType {
  PIPELINE_INTEGRATION = 'pipelineIntegration',
  BLOCK_HEADER = 'blockHeader',
  REPOSITORY = 'repository',
  REPOSITORIES = 'repositories',
  NAME = 'name',
  STEP = 'step',
  PARAMETER = 'parameter',
  OUTPUT_PARAMETER = 'outputParameter',
  JOB_PARAMETER = 'jobParameter',
  SECRET = 'secret',
  TRIGGER = 'trigger',
  DEPENDENCY = 'dependency',
}

type PipelineFormState = {
  open: boolean
  isAdd?: boolean
}
export type PipelineFormsState = KeyValue<string, KeyValue<string, PipelineFormState>>
export type PipelineFormParams = {
  pipelineId: PipelineId
  jobId?: string | null
  id?: string | number
  type: FormType
  isAdd?: boolean
}
